import { primaryRegularFont, theme } from '@noths/polaris-client-ribbons-base';
import { smallElevation } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

const logoSize = 56;

export const root = css`
  display: flex;
  column-gap: ${spacing.sm}px;
  align-items: center;
  justify-content: space-between;
  border-radius: ${spacing.md}px;
  padding: ${spacing.sm}px;
  background-color: ${palette.blue5};
  ${primaryRegularFont};
  ${responsiveText.BODY.SM};

  img {
    flex-grow: 0;
    border-radius: 50%;
    width: ${logoSize}px;
    height: ${logoSize}px;
    object-fit: contain;
    ${smallElevation};
    background-color: var(--neutral-white-base);
  }

  ul {
    flex-grow: 1;
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  li span:has(> span[data-testid^='icon-']) {
    display: inline-block;
    margin-right: 5px;
    vertical-align: text-bottom;
  }

  a {
    color: ${palette.blueBase};
  }
`;
